import { defineStore } from 'pinia'

export const useRadioSettingsStore = defineStore('radioSettings', {
    state: () => ({
        // 編集中の端末設定情報。保存のタイミングで仮データをこちらに保存し、表示などで参照する。
        setting: {},

        // 仮保存用の端末設定情報。保存するまではこちらを編集。
        tempSetting: {},
    }),

    actions: {
        // ストアに保存されている端末情報を取得
        getSetting() {
            return JSON.parse(JSON.stringify(this.setting))
        },

        // ストアに保存されている端末情報を更新
        saveSetting(data) {
            this.setting = data
            this.tempSetting = data
        },

        // 仮保存中の端末情報を取得
        getTempSetting() {
            return JSON.parse(JSON.stringify(this.tempSetting))
        },

        // 端末設定情報を仮保存する
        saveTempSetting(data) {
            this.tempSetting = data
        },

        // 端末設定の仮保存値を破棄して、保存済みの値で上書きする
        discardTempSetting() {
            this.tempSetting = this.setting
        },
    },
})
